<template lang="pug">
.usage-fees-tokuyo-care-insurance-service-costs-table
  .d-flex.flex-row.align-items-center.mb-2
    .title.mr-1 介護保険給付サービス利用料（1割負担の金額、日額） ※ 募集ページでは30日分を月額として概算
    span.validation-label 必須
  b-table-simple.dark-boder-table.waiter-judge-template-table
    b-thead
      b-tr
        b-th 部屋種類
        b-th 要介護1
        b-th 要介護2
        b-th 要介護3
        b-th 要介護4
        b-th 要介護5
    b-tbody
      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-if="showRomType('multiBed')" v-model="_value.multiBed" roomId="multiBed" roomName="従来型多床室")
      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-if="showRomType('conventinalSingle')" v-model="_value.conventinalSingle" roomId="conventinalSingle" roomName="従来型個室")
      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-if="showRomType('unitTypeSingle')" v-model="_value.unitTypeSingle" roomId="unitTypeSingle" roomName="ユニット型個室")
      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-if="showRomType('double')" v-model="_value.double" roomId="double" roomName="２人部屋（夫婦部屋）")
      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-if="showRomType('single')" v-model="_value.single" roomId="single" roomName="個室")

      UsageFeesTokuyoCareInsuranceServiceCostsTableRow(v-for="(customRoom, index) in _value.customRecruitmentRoom" v-model="_value.customRecruitmentRoom[index]"
        :roomId="customRoom.id" :roomName="customRoom.roomName")

  .errors(v-for="fieldName in _fieldNames")
    .error-messages(v-for="error in errors.collect(fieldName)")
      .error-message {{ error }}
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

import { LivingCosts } from "@/commons/services/WaiterRecruitments";
import { FacilityGetModel } from "@/commons/services/Facilities";

import UsageFeesTokuyoCareInsuranceServiceCostsTableRow from "@/pc/containers/waiters/UsageFeesTokuyoCareInsuranceServiceCostsTableRow.vue";

/**
 * ### 料金シミュレーション(特養タイプ) 部屋料金コンポーネント
 */
@Component({
  components: {
    UsageFeesTokuyoCareInsuranceServiceCostsTableRow
  }
})
export default class UsageFeesTokuyoCareInsuranceServiceCostsTable extends Vue {
  /** 親コンポーネントのバリデーターをInjectionする */
  @Inject("$validator") $validator!: Validator;

  @Prop()
  value!: LivingCosts;

  @Prop()
  facility!: FacilityGetModel;

  get _value(): LivingCosts {
    return this.value;
  }

  set _value(newValue: LivingCosts) {
    this.$emit("input", newValue);
    return;
  }

  get _fieldNames(): string[] {
    let fieldNames: string[] = [];
    fieldNames = fieldNames.concat(this.createFieldNames("multiBed"));
    fieldNames = fieldNames.concat(this.createFieldNames("conventinalSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("unitTypeSingle"));
    fieldNames = fieldNames.concat(this.createFieldNames("single"));
    fieldNames = fieldNames.concat(this.createFieldNames("double"));

    return fieldNames;
  }

  public createFieldNames(roomName: string): string[] {
    return [
      `usage-fees-tokuyo-${roomName}-care-level-1`,
      `usage-fees-tokuyo-${roomName}-care-level-2`,
      `usage-fees-tokuyo-${roomName}-care-level-3`,
      `usage-fees-tokuyo-${roomName}-care-level-4`,
      `usage-fees-tokuyo-${roomName}-care-level-5`
    ];
  }

  /**
   * ### 施設が表示対象にしている部屋種類か否かを返す
   */
  public showRomType(roomTypeName: string): boolean {
    switch (roomTypeName) {
      case "multiBed": {
        return this.facility.recruitmentRoom.multiBed;
      }
      case "conventinalSingle": {
        return this.facility.recruitmentRoom.conventinalSingle;
      }
      case "unitTypeSingle": {
        return this.facility.recruitmentRoom.unitTypeSingle;
      }
      case "double": {
        return this.facility.recruitmentRoom.double;
      }
      case "single": {
        return this.facility.recruitmentRoom.single;
      }
      default: {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.usage-fees-tokuyo-care-insurance-service-costs-table {
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .validation-label {
    color: $validation-label-font-color;
    font-size: 10px;
    border: 1px solid $validation-label-font-color;
    padding: 1px 4px 0 4px;
    // 「必須」の文字が少し下にズレるでの、marginで調整する
    margin: 2px 6px 4px 0;
  }
}
</style>
